import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  VStack,
  Text,
  Code,
  Flex,
  IconButton,
  useClipboard,
  Tooltip,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import { CopyIcon, CheckIcon } from "@chakra-ui/icons";

const DecodeValuesModal = ({ isOpen, onClose, resultValues, types, keys }) => {
  const [decodedData, setDecodedData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (isOpen && resultValues && types && keys && types.length === keys.length) {
      try {
        const abiCoder = new ethers.utils.AbiCoder();
        const decodedArray = abiCoder.decode(types, resultValues);

        const dataObject = keys.reduce((acc, key, index) => {
          acc[key] = decodedArray[index] ? decodedArray[index].toString() : "N/A";
          return acc;
        }, {});

        setDecodedData(dataObject);
        setError(null);
      } catch (e) {
        console.error("Decoding error:", e);
        setError(`Error decoding: ${e.message}`);
        setDecodedData(null);
      }
    } else {
      setDecodedData(null);
      setError(null);
      if (isOpen && types && keys && types.length !== keys.length) {
        setError("Error: The number of types and keys must match.");
      }
    }
  }, [isOpen, resultValues, types, keys]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="xl">
      <ModalOverlay />
      <ModalContent bg="gray.800">
        <ModalHeader color="white">Decoded Result Values</ModalHeader>
        <ModalCloseButton color="white" />
        <ModalBody pb={6}>
          {error ? (
            <Text color="red.400">{error}</Text>
          ) : decodedData ? (
            <VStack align="stretch" spacing={3}>
              {Object.entries(decodedData).map(([key, value]) => (
                <DecodeItem key={key} label={key} value={value} />
              ))}
            </VStack>
          ) : (
            <Text color="gray.500">Decoding...</Text>
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} colorScheme="blue">Close</Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

const DecodeItem = ({ label, value }) => {
  const { hasCopied, onCopy } = useClipboard(value);

  return (
    <Flex justify="space-between" align="flex-start" w="100%">
      <Text color="gray.300" fontWeight="semibold" mr={3} whiteSpace="nowrap">
        {label}:
      </Text>
      <Flex 
        align="flex-start" 
        flexGrow={1} 
        justifyContent="flex-end" 
      >
        <Code 
          colorScheme="gray" 
          p={1} 
          px={2} 
          borderRadius="md" 
          wordBreak="break-all"
          maxW="calc(100% - 40px)" 
          mr={2} 
          fontSize="sm" 
        >
          {value}
        </Code>
        <Tooltip label={hasCopied ? "Copied!" : "Copy value"} placement="top" closeOnClick={false}>
          <IconButton
            aria-label="Copy value"
            icon={hasCopied ? <CheckIcon /> : <CopyIcon />} 
            size="sm"
            onClick={onCopy}
            variant="ghost"
            colorScheme={hasCopied ? "green" : "gray"}
          />
        </Tooltip>
      </Flex>
    </Flex>
  );
};

export default DecodeValuesModal;
